<template>
    <section class="section cta-area bg-overlay ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10">
                    <!-- Section Heading -->
                    <div class="section-heading text-center m-0">
                        <h2 class="text-white">Potrebne su Vam naše usluge?</h2>
                        <a href="mailto:office@vmpartners.rs" class="btn btn-bordered-white mt-4">Kontaktirajte Nas</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
